module.exports = __webpack_public_path__ + "img/logo.aab9682e.png";